import {
    Component,
    OnInit,
    AfterViewInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service';
import {
    ActivatedRoute,
    Router
} from '@angular/router';



@Component({
    templateUrl: './AppViews/MultiLocationTask/multilocationtaskforms.html',
    styleUrls: ['./AppViews/MultiLocationTask/multilocationtaskforms.css']
})

export class multiLocationTaskFormsComponent implements OnInit, AfterViewInit {

    constants: Constants;
    userDetail: any;
    filter: any = {
        'CustomerId': 0,
        'FromDate': "",
        'ToDate': "",
        'StatusId': "0"
    };
    active = true;
    projectFilterFlag: any;
    getMultiLocationTaskUrl: any;
    getTaskLocationUrl: any;
    public showLoader = false;
    selfuser: boolean = true;
    multiLocationTaskItems: any = [];
    customerList: any = [];
    cityData: any = [];
    stateData: any = [];
    userData: any = [];
    isAdd: boolean = true;
    documentRoute: any;
    currentLocationTask: any;
    addEditMultiLocationTaskData: any = {
        CustomerId: "",
        CustomerName: "",
        EstimatedHours: "",
        PlannedEndDate: "",
        PlannedStartDate: "",
        ProjectId: "",
        ProjectName: "",
        ScopeOfWork: "",
        Status: "",
        StatusId: 1,
        TaskCompletionCount: "",
        TaskDescription: "",
        TaskId: "",
        TaskOwner: "",
        TaskOwnerId: "",
        TaskTitle: "",
        TaskGroupId: "",
        TaskTypeName: "",
        TotalLocationCount: "",
        SwanContact: ""
    };
    addTaskLocationData: any = {
        Comment: "",
        CompletedOn: "",
        CustomerPersonName: "",
        Fee: "",
        ImageUploadFile: "",
        InstallationRemark: "",
        InstallationReport: "",
        Instruction: "",
        LocationCode: "",
        LocationId: "",
        LocationName: "",
        PlannedEndDate: "",
        PlannedStartDate: "",
        ProjectName: "",
        Status: "",
        StatusId: 1,
        TaskId: "",
        TaskLocationId: "",
        TaskName: "",
        VendorId: "",
        VendorName: ""
    };
    editTaskLocationData: any = {
        Comment: "",
        CompletedOn: "",
        CustomerPersonName: "",
        Fee: "",
        ImageUploadFile: "",
        InstallationRemark: "",
        InstallationReport: "",
        Instruction: "",
        LocationCode: "",
        LocationId: "",
        LocationName: "",
        PlannedEndDate: "",
        PlannedStartDate: "",
        ProjectName: "",
        Status: "",
        StatusId: "",
        TaskId: "",
        TaskLocationId: "",
        TaskName: "",
        VendorId: "",
        VendorName: ""
    }
    taskLocationList: any = [];
    isMultiLocationTaskFormSubmitted: boolean;
    isTaskLocationFormSubmitted: boolean;
    taskStatusItems: any = [];
    projectListData: any = [];
    taskTypeItems: any = [];
    multiLocationTaskData: any = {};
    getCustomerLocationUrl: any;
    customerLocationListItems: any = [];
    vendorsList: any = [];
    taskLocationStatusList: any = [];
    reportFile: any;
    InstallationReport: any = [];
    InstallationReportPath: any;
    ImageUploadFile: any = [];
    ImageUploadFilePath: any;
    taskCommentsList: any = [];
    addTaskCommentData: any = {
        TaskLogId: 0,
        TaskLocationId: 0,
        StatusId: 0,
        Comments: "",
        TaskDate: "",
        CreatedBy: "",
        AssignedTo: ""
    };
    isAddCommentsFormSubmitted: boolean;
    fileList: any;
    showComments: boolean = true;
    isValidFromTo: boolean = true;
    taskgroupList: any = [];

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.route
            .params
            .subscribe(
                data => {
                    this.filter.TaskId = data["TaskId"];
                }
            );
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.TeamId = "";
        // this.projectFilterFlag = JSON.parse(localStorage.getItem('ProjectFilters'));
        this.getTaskLocationUrl = "LocationTask/GetTaskLocationList";
        this.getMultiLocationTaskUrl = "LocationTask/GetTaskForVendor";
        this.getCustomerLocationUrl = "CustomerLocation/GetCustomerLocation";

    }

    ngOnInit() {
        if (this.filter.TaskId != 0) {
            this.GetMultiTaskLocationData(true);
        }
        this.BindDropdownData();

    }

    ngAfterViewInit() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $('.CompletedOndate').datetimepicker({
            format: 'DD/MM/YYYY',
            maxDate: moment().set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            })
        });


    }

    GetMultiTaskLocationData(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            //to handle executives case
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        } else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost(this.getMultiLocationTaskUrl, {
            "TaskId": this.filter.TaskId,
            "CustomerId": this.filter.CustomerId,
            "FromDate": this.filter.FromDate,
            "ToDate": this.filter.ToDate,
            "StatusId": this.filter.StatusId,
            "LoggedInUser": UserId

        }).subscribe(
            data => {
                this.multiLocationTaskData = data["LocationTaskList"][0];
                let objTaskItem: any = {};
                objTaskItem = JSON.parse(JSON.stringify(this.multiLocationTaskData));
                this.currentLocationTask = objTaskItem;
                this.addEditMultiLocationTaskData.CustomerId = objTaskItem.CustomerId;
                this.filter.CustomerId = objTaskItem.CustomerId;
                this.GetProjectData();
                this.getTaskGroupByProjectId(objTaskItem.ProjectId);
                this.addEditMultiLocationTaskData.CustomerName = objTaskItem.CustomerName;
                this.addEditMultiLocationTaskData.EstimatedHours = objTaskItem.EstimatedHours;
                this.addEditMultiLocationTaskData.PlannedEndDate = objTaskItem.PlannedEndDate;
                this.addEditMultiLocationTaskData.PlannedStartDate = objTaskItem.PlannedStartDate;
                this.addEditMultiLocationTaskData.ProjectId = objTaskItem.ProjectId;
                this.addEditMultiLocationTaskData.ProjectName = objTaskItem.ProjectName;
                this.addEditMultiLocationTaskData.Status = objTaskItem.Status;
                this.addEditMultiLocationTaskData.StatusId = objTaskItem.StatusId;
                this.addEditMultiLocationTaskData.TaskCompletionCount = objTaskItem.TaskCompletionCount;
                this.addEditMultiLocationTaskData.TaskId = objTaskItem.TaskId;
                this.addEditMultiLocationTaskData.TaskOwner = objTaskItem.TaskOwner;
                this.addEditMultiLocationTaskData.TaskOwnerId = objTaskItem.TaskOwnerId;
                this.addEditMultiLocationTaskData.TaskGroupId = objTaskItem.TaskGroupId;
                this.addEditMultiLocationTaskData.TaskTypeName = objTaskItem.TaskTypeName;
                this.addEditMultiLocationTaskData.TotalLocationCount = objTaskItem.TotalLocationCount;
                this.addEditMultiLocationTaskData.SwanContact = objTaskItem.SwanContact;
                this.addEditMultiLocationTaskData.ScopeOfWork = objTaskItem.ScopeOfWork;
                this.addEditMultiLocationTaskData.TaskTitle = objTaskItem.TaskTitle;
                this.addEditMultiLocationTaskData.TaskDescription = objTaskItem.TaskDescription;
            },
            err => {
                this.showLoader = false;
                console.log("GetMultiLocationTaskList Failed with status: " + err.status);
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                this.isMultiLocationTaskFormSubmitted = false;
                console.log(this.multiLocationTaskData);
                if (this.filter.TaskId != 0) {
                    this.GetLocationTaskList();
                    this.GetUserListForProject(this.addEditMultiLocationTaskData.ProjectId);
                }

            }
        );
    }

    GetLocationTaskList() {
        this.showLoader = true;
        this._httpService.ajaxPost(this.getTaskLocationUrl, {
            "TaskId": this.filter.TaskId,
            "TaskLocationId": 0,
            "VendorId": 0
        }).subscribe(
            data => {
                this.taskLocationList = data["TaskLocationList"];
                if (this.filter.TaskId != 0 && this.taskLocationList.length > 0) {
                    this.InstallationReport = this.taskLocationList[0].InstallationReport;
                    this.ImageUploadFile = this.taskLocationList[0].ImageUploadFile
                    this.documentRoute = data["FilePath"];
                }


            },
            err => {
                this.showLoader = false;
                console.log("GetLocationTaskData Failed with status: " + err.status);
            },
            () => {
                this.showLoader = false;
                console.log("TaskLocationList: ");
                console.log(this.taskLocationList);
            }
        );
    }




    BindDropdownData() {
        this.showLoader = true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        //if(this.filter.TeamId==""){
        TeamId = 0

        //}
        // else{
        //     TeamId = this.filter.TeamId;
        // }

        this.showLoader = true;
        this._httpService.ajaxPost('TaskType/GetTaskType', {
            "TaskTypeId": 0,
            "TaskGroupId": 0,
            "IsActive": this.constants.enumUserStatus["Active"]
        }).subscribe(
            data => {
                this.taskTypeItems = data["TaskType"];
            },
            err => {
                this.showLoader = false;
                console.log("BindFilters Failed");
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                // console.log(this.taskTypeItems);

                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter', {
                    "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"]
                }).subscribe(
                    data => {
                        this.taskStatusItems = data["Parameter"];
                        this.taskStatusItems.sort(function (a, b) {
                            if (a.ParameterDescription.toLowerCase() < b.ParameterDescription.toLowerCase()) return -1;
                            if (a.ParameterDescription.toLowerCase() > b.ParameterDescription.toLowerCase()) return 1;
                            return 0;
                        })
                    },
                    err => {
                        this.showLoader = false;
                        console.log("GetParameter Failed with status: " + err.status);
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = false;
                        // this.GetProjectData();
                        this.GetVendorsList();
                        this.GetLocationList();
                        this.GetCustomerList();
                        this.GetTaskLocationStatusList();
                        // console.log(this.taskStatusItems);
                    }
                );
            }

        );
    }

    GetUserListForProject(projectId: any) {
        this._httpService.ajaxPost('LocationTask/GetProjectTaskOwner', {
            "ProjectId": projectId
        }).subscribe(
            data => {
                this.userData = data["Users"];
            },
            err => {
                this.showLoader = false;
                console.log("BindFilters Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    GetLocationList() {
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            //to handle executives case
            //  if(this.userDetail.RoleId==3){
            TeamId = 0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        } else {
            TeamId = this.filter.TeamId;
        }
        console.log("CustomerId for customerlocation: ");
        console.log(this.filter.CustomerId);
        this.showLoader = true;
        this._httpService.ajaxPost(this.getCustomerLocationUrl, {
            "CustomerLocationId": 0,
            "CustomerId": this.filter.CustomerId
        }).subscribe(
            data => {
                this.customerLocationListItems = data["CustomerLocationList"];
            },
            err => {
                console.log("GetLocationList Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                // console.log("cusomterLocationListItems:");
                // console.log(this.customerLocationListItems);
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetTaskLocationStatusList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["TaskStatusType"]
        }).subscribe(
            data => {
                this.taskLocationStatusList = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                // console.log("Task location status:")
                // console.log(this.taskLocationStatusList);
                this.showLoader = false;
            }
        )

    }

    GetVendorsList() {
        this.showLoader = true;
        this._httpService.ajaxPost('Vendors/GetVendors', {
            "VendorId": 0,
            "IsActive": "" //this.constants.enumCustomerStatus["Active"]
        }).subscribe(
            data => {
                this.vendorsList = data["Vendors"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                // console.log("Vendors:");
                // console.log(this.vendorsList);
                this.showLoader = false;
            }
        );
    }

    GetCustomerList() {
        this._httpService.ajaxPost('Customer/GetCustomer', {
            "CustomerId": 0,
            "CountryId": 0,
            "CustomerStatus": true
        }).subscribe(
            data => {
                this.customerList = data["CustomerList"];
            },
            err => {
                console.log("GetCustomerList Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                // console.log(this.customerList);
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetProjectData() {
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        //if(this.filter.TeamId==""){
        TeamId = 0

        //}
        // else{
        //     TeamId = this.filter.TeamId;
        // }
        this.showLoader = true;

        this._httpService.ajaxPost('LocationTask/GetProjectNew', {
            "ProjectId": 0,
            "OwnerTeamId": this.userDetail.TeamID,
            "ProjectType": "",
            "Status": this.constants.enumProjectStatus["Open"],
            "UserId": UserId,
            "CustomerId": this.filter.CustomerId,
            "SiteId": ""
        }).subscribe(
            data => {
                this.projectListData = data["ProjectList"];

            },
            err => {
                this.showLoader = false;
                console.log("GetProjectData Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                console.log("ProjectList: ");
                console.log(this.projectListData);
                this.showLoader = false;
                //this.filter.CustomerId = 0;
            }
        );
    }

    public getTaskGroupByProjectId(val) {
    this.showLoader = true;
    this._httpService
      .ajaxPost("Project/GetProjectById", { ProjectId: val })
      .subscribe(
        (data) => {
          this.taskgroupList = data["ProjectList"];
        },
        (err) => {
          console.log("GetProjectidList Failed");
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        }
      );
  }

    dateCompare(startDate: any, endDate: any): boolean {
        this.isValidFromTo = true;
        if (startDate != "" && startDate != null)
            startDate = moment(startDate, 'DD/MM/YYYY');

        if (endDate != "" && endDate != null)
            endDate = moment(endDate, 'DD/MM/YYYY');

        if ((endDate != "" && endDate != null) && (startDate != "" && startDate != null)) {
            if (endDate.isBefore(startDate))
                this.isValidFromTo = false;
        }
        return this.isValidFromTo;
    }


    addUpdateMultiLocationTask(form ? : any) {
        this.isMultiLocationTaskFormSubmitted = true;
        if (this.dateCompare(this.addEditMultiLocationTaskData.PlannedStartDate, this.addEditMultiLocationTaskData.PlannedEndDate)) {
            if (form.form.valid) {
                let objItem: any = {};
                objItem.TaskId = this.addEditMultiLocationTaskData.TaskId;
                objItem.ProjectId = this.addEditMultiLocationTaskData.ProjectId;
                objItem.TaskGroupId = this.addEditMultiLocationTaskData.TaskGroupId;
                objItem.TaskTitle = this.addEditMultiLocationTaskData.TaskTitle;
                objItem.TaskDescription = this.addEditMultiLocationTaskData.TaskDescription;
                objItem.TaskOwnerId = this.addEditMultiLocationTaskData.TaskOwnerId;
                objItem.EstimatedHours = this.addEditMultiLocationTaskData.EstimatedHours;
                objItem.PlannedStartDate = this.addEditMultiLocationTaskData.PlannedStartDate;
                objItem.PlannedEndDate = this.addEditMultiLocationTaskData.PlannedEndDate;
                objItem.ScopeOfWork = this.addEditMultiLocationTaskData.ScopeOfWork;
                objItem.StatusId = this.addEditMultiLocationTaskData.StatusId;
                objItem.SwanContact = this.addEditMultiLocationTaskData.SwanContact;
                objItem.CreatedBy = this.userDetail.SiteUserId;

                console.log("MultiTaskLocationData: ");
                console.log(objItem);

                this.addEditMultiLocationTask(objItem);
                //close tab

            }
        }
    }

    addEditMultiLocationTask(objItem: any) {
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/AddUpdateLocationTask', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                } else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }

                if (msg[0] == "success") {
                    // this.GetMultiTaskLocationData(false);
                    this._route.navigateByUrl("/multiLocationTask");
                }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },

            () => {
                this.showLoader = false;

            }
        );
    }

    EditLocationTask(item: any) {
        // $('#resetEditLocationTaskForm').trigger('click');
        $('#InstallationReport').val('');
        $('#ImageUploadFile').val('');
        this.isAdd = false;
        this.filter.TaskLocationId = item.TaskLocationId;
        this.ImageUploadFile = "";
        this.InstallationReport = "";
        this.EditLocationTaskChange(item.TaskLocationId);

    }

    ShowAddComments(item: any) {
        this.AddCommentsFormLoad();
        this.filter.TaskLocationId = item.TaskLocationId;
        this.GetTaskLocationComments(item.TaskLocationId);


    }

    public CancelEditCustomerLocation() {
        //this.editTaskLocationData = {};
        $('#editLocationTask').modal('hide');
        this.isAdd = true;
    }

    public CancelAddLocationTask() {
        //this.addTaskLocationData = {};
        $('#addLocationTask').modal('hide');
        this.isAdd = true;
    }

    EditLocationTaskChange(itemId: any) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.taskLocationList.filter((taskLocation) => taskLocation.TaskLocationId == itemId)[0]));
        if (objItem.Comment) this.editTaskLocationData.Comment = objItem.Comment;
        else this.editTaskLocationData.Comment = "";
        if (objItem.CompletedOn) this.editTaskLocationData.CompletedOn = objItem.CompletedOn;
        else this.editTaskLocationData.CompletedOn = "";
        if (objItem.CustomerPersonName) this.editTaskLocationData.CustomerPersonName = objItem.CustomerPersonName;
        else this.editTaskLocationData.CustomerPersonName = "";
        if (objItem.Fee) this.editTaskLocationData.Fee = objItem.Fee;
        else this.editTaskLocationData.Fee = 0;
        if (objItem.ImageUploadFile) {
            this.editTaskLocationData.ImageUploadFile = objItem.ImageUploadFile;
            this.ImageUploadFile = objItem.ImageUploadFile;
        } else {
            this.editTaskLocationData.ImageUploadFile = "";
            this.ImageUploadFile = "";
        }
        if (objItem.InstallationRemark) this.editTaskLocationData.InstallationRemark = objItem.InstallationRemark;
        else this.editTaskLocationData.InstallationRemark = "";

        if (objItem.InstallationReport) {
            this.editTaskLocationData.InstallationReport = objItem.InstallationReport;
            this.InstallationReport = objItem.InstallationReport;
        } else {
            this.editTaskLocationData.InstallationReport = "";
            this.InstallationReport = "";
        }
        if (objItem.Instruction) this.editTaskLocationData.Instruction = objItem.Instruction;
        else this.editTaskLocationData.Instruction = "";
        if (objItem.LocationCode) this.editTaskLocationData.LocationCode = objItem.LocationCode;
        else this.editTaskLocationData.LocationCode = "";
        if (objItem.LocationId) this.editTaskLocationData.LocationId = objItem.LocationId;
        else this.editTaskLocationData.LocationId = "";
        if (objItem.LocationName) this.editTaskLocationData.LocationName = objItem.LocationName;
        else this.editTaskLocationData.LocationName = "";
        if (objItem.PlannedEndDate) this.editTaskLocationData.PlannedEndDate = objItem.PlannedEndDate;
        else this.editTaskLocationData.PlannedEndDate = "";
        if (objItem.PlannedStartDate) this.editTaskLocationData.PlannedStartDate = objItem.PlannedStartDate;
        else this.editTaskLocationData.PlannedStartDate = "";
        if (objItem.ProjectName) this.editTaskLocationData.ProjectName = objItem.ProjectName;
        else this.editTaskLocationData.ProjectName = "";
        if (objItem.Status) this.editTaskLocationData.Status = objItem.Status;
        else this.editTaskLocationData.Status = "";
        if (objItem.StatusId) this.editTaskLocationData.StatusId = objItem.StatusId;
        else this.editTaskLocationData.StatusId = "";
        if (objItem.TaskId) this.editTaskLocationData.TaskId = objItem.TaskId;
        else this.editTaskLocationData.TaskId = "";
        if (objItem.TaskLocationId) this.editTaskLocationData.TaskLocationId = objItem.TaskLocationId;
        else this.editTaskLocationData.TaskLocationId = "";
        if (objItem.TaskName) this.editTaskLocationData.TaskName = objItem.TaskName;
        else this.editTaskLocationData.TaskName = "";
        if (objItem.VendorId) this.editTaskLocationData.VendorId = objItem.VendorId;
        else this.editTaskLocationData.VendorId = "";
        if (objItem.VendorName) this.editTaskLocationData.VendorName = objItem.VendorName;
        else this.editTaskLocationData.VendorName = "";

        // if (objItem.InstallationReport) this.InstallationReport = objItem.InstallationReport;
        // else this.InstallationReport = "";
        // if (objItem.InstallationReport) this.ImageUploadFile = objItem.InstallationReport;
        // else this.ImageUploadFile = "";

    }

    GetTaskLocationComments(TaskLocationId: any) {
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/GetTaskCommentList', {
            "TaskLocationId": TaskLocationId
        }).subscribe(
            data => {
                this.taskCommentsList = data["CommentList"];
            },
            err => {
                this.showLoader = false;
                console.log("GetTaskLocationComments Failed");
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
                // console.log("Comments:");
                // console.log(this.taskCommentsList);
            }
        )
    }

    public CancelEditLocationTask() {
        $('#editLocationTask').modal('hide');
        this.isAdd = true;
    }

    public CancelShowComments() {
        $('#showAddComments').modal('hide');
    }

    public UpdateLocationTask(form ? : any) {
        this.isTaskLocationFormSubmitted = true;

        if (this.dateCompare(this.editTaskLocationData.PlannedStartDate, this.editTaskLocationData.PlannedEndDate)) {
            if (form.form.valid) {
                let objItem: any = {};
                // objItem.Comment = this.editTaskLocationData.Comment;
                objItem.CompletedOn = this.editTaskLocationData.CompletedOn;
                objItem.CustomerPersonName = this.editTaskLocationData.CustomerPersonName;
                objItem.Fee = this.editTaskLocationData.Fee;
                objItem.ImageUploadFile = this.editTaskLocationData.ImageUploadFile;
                objItem.InstallationRemark = this.editTaskLocationData.InstallationRemark;
                objItem.InstallationReport = this.editTaskLocationData.InstallationReport;
                objItem.Instructions = this.editTaskLocationData.Instruction;
                // objItem.LocationCode = this.editTaskLocationData.LocationCode;
                objItem.LocationId = this.editTaskLocationData.LocationId;
                // objItem.LocationName = this.editTaskLocationData.LocationName;
                objItem.PlannedEndDate = this.editTaskLocationData.PlannedEndDate;
                objItem.PlannedStartDate = this.editTaskLocationData.PlannedStartDate;
                // objItem.ProjectName = this.editTaskLocationData.ProjectName;
                // objItem.Status = this.editTaskLocationData.Status;
                objItem.StatusId = this.editTaskLocationData.StatusId;
                objItem.TaskId = this.editTaskLocationData.TaskId;
                objItem.TaskLocationId = this.filter.TaskLocationId;
                // objItem.TaskName = this.editTaskLocationData.TaskName;
                objItem.VendorId = this.editTaskLocationData.VendorId;
                objItem.CreatedBy = this.userDetail.SiteUserId;
                // objItem.VendorName = this.editTaskLocationData.VendorName;
                console.log("UpdateLocationTask:");
                console.log(objItem);
                this.addEditLocationTaskData(objItem);
                this.isAdd = true;
            }
        }
    }

    addEditLocationTaskData(TaskLocationModel) {
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/AddUpdateTaskLocation', TaskLocationModel)
            .subscribe(
                data => {
                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }

                    if (msg[0] == "success") {
                        $('#addLocationTask').modal('hide');
                        $('#editLocationTask').modal('hide');
                        this.GetLocationTaskList();
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },

                () => {
                    this.showLoader = false;

                }
            );
    }

    public ResetLocationTaskForm(form: any) {
        form.reset();
        form.resetForm();
        // setTimeout(() => {
        //     this.addTaskLocationData.VendorId = "";
        //     this.addTaskLocationData.StatusId = "";
        //     this.addTaskLocationData.LocationId = "";

        //     this.editTaskLocationData.VendorId = "";
        //     this.editTaskLocationData.StatusId = "";
        //     this.editTaskLocationData.LocationId = "";
        // }, 0);

        setTimeout(() => {
            this.addTaskLocationData = {
                Comment: "",
                CompletedOn: "",
                CustomerPersonName: "",
                Fee: 0,
                ImageUploadFile: "",
                InstallationRemark: "",
                InstallationReport: "",
                Instruction: this.currentLocationTask.TaskDescription,
                LocationCode: "",
                LocationId: "",
                LocationName: "",
                PlannedEndDate: this.currentLocationTask.PlannedEndDate,
                PlannedStartDate: this.currentLocationTask.PlannedStartDate,
                ProjectName: "",
                Status: "",
                StatusId: 1,
                TaskId: "",
                TaskLocationId: "",
                TaskName: "",
                VendorId: "",
                VendorName: ""
            };
            this.ImageUploadFile = "";
            this.InstallationReport = "";
        }, 0);

        this.isTaskLocationFormSubmitted = false;
    }

    public ResetAddComments(form: any) {
        form.reset();
        form.resetForm();

        setTimeout(() => {
            this.addTaskCommentData.Comments = "";
        }, 0);
    }

    public AddLocationTask(form ? : any) {
        this.isTaskLocationFormSubmitted = true;

        if (form.form.valid) {
            let objItem: any = {};

            objItem.TaskLocationId = 0;
            objItem.TaskId = this.filter.TaskId;
            if (this.addTaskLocationData.LocationId) objItem.LocationId = this.addTaskLocationData.LocationId;
            else objItem.LocationId = "";
            if (this.addTaskLocationData.PlannedStartDate) objItem.PlannedStartDate = this.addTaskLocationData.PlannedStartDate;
            else objItem.PlannedStartDate = "";
            if (this.addTaskLocationData.PlannedEndDate) objItem.PlannedEndDate = this.addTaskLocationData.PlannedEndDate;
            else objItem.PlannedEndDate = "";
            if (this.addTaskLocationData.Instruction) objItem.Instructions = this.addTaskLocationData.Instruction;
            else objItem.Instructions = "";
            if (this.addTaskLocationData.Fee) objItem.Fee = this.addTaskLocationData.Fee;
            else objItem.Fee = 0;
            if (this.addTaskLocationData.VendorId) objItem.VendorId = this.addTaskLocationData.VendorId;
            else objItem.VendorId = "";
            if (this.addTaskLocationData.StatusId) objItem.StatusId = this.addTaskLocationData.StatusId;
            else objItem.StatusId = "";
            if (this.addTaskLocationData.CustomerPersonName) objItem.CustomerPersonName = this.addTaskLocationData.CustomerPersonName;
            else objItem.CustomerPersonName = "";
            if (this.addTaskLocationData.InstallationReport) objItem.InstallationReport = this.addTaskLocationData.InstallationReport;
            else objItem.InstallationReport = "";
            if (this.addTaskLocationData.ImageUploadFile) objItem.ImageUploadFile = this.addTaskLocationData.ImageUploadFile;
            else objItem.ImageUploadFile = "";
            if (this.addTaskLocationData.InstallationRemark) objItem.InstallationRemark = this.addTaskLocationData.InstallationRemark;
            else objItem.InstallationRemark = "";
            if (this.addTaskLocationData.CompletedOn) objItem.CompletedOn = this.addTaskLocationData.CompletedOn;
            else objItem.CompletedOn = "";
            objItem.CreatedBy = this.userDetail.SiteUserId;

            console.log("AddLocationTask:")
            console.log(objItem);
            this.addEditLocationTaskData(objItem);


            this.isAdd = true;
        }
    }

    AddTaskComment(form: any) {
        this.isAddCommentsFormSubmitted = true;
        var dateNow = moment(new Date()).format('DD/MM/YYYY');
        if (form.form.valid) {
            let objItem: any = {};
            objItem.TaskLogId = this.addTaskCommentData.TaskLogId;
            objItem.TaskLocationId = this.filter.TaskLocationId;
            objItem.StatusId = this.addTaskCommentData.StatusId;
            objItem.Comments = this.addTaskCommentData.Comments;
            objItem.TaskDate = dateNow.toString();
            objItem.CreatedBy = this.userDetail.SiteUserId;
            objItem.AssignedTo = this.userDetail.SiteUserId;
            // console.log(objItem);
            this.addUpdateTaskComments(objItem);


        }
    }

    addUpdateTaskComments(objItem: any) {
        let TaskLocationId = objItem.TaskLocationId;
        this.showLoader = true;
        this._httpService.ajaxPost('LocationTask/AddUpdateTaskComment', objItem)
            .subscribe(
                data => {
                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        msg[0] = msg[0].toLowerCase();
                        this._sharedService.ShowMessage(data["Status"].Message);
                    } else {
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }

                    if (msg[0] == "success") {
                        $('#showAddComments').modal('hide');

                        this.GetTaskLocationComments(TaskLocationId);
                        this.GetLocationTaskList();
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;

                }
            );
    }

    ExportDataInExcel() {
        this.showLoader = true;

        this._httpService.ajaxPost("LocationTask/ExportStatusReport", {
            "TaskId": this.filter.TaskId,
            "TaskLocationId": 0,
            "VendorId": 0
        }).subscribe(

            data => {
                this.reportFile = data["ReportFile"];
                window.location.href = this.reportFile;
            },
            err => {
                console.log("Export customer locations Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                this.showLoader = false;
            });
    }

    fileEventInstallationReport(event, value) {
        this.showLoader = true;
        let TaskIdString: string = this.filter.TaskId.toString();
        console.log("TaskIdString: " + TaskIdString);
        let file: File = (event.target).files[0];
        this.fileList = (event.target).files;

        this._httpService.ajaxPostFile('LocationTask/AddUpdateFile', this.fileList).then((response) => {
                if (value == 1) {
                    if (response["FileName"] != null) {
                        this.editTaskLocationData.InstallationReport = response["FileName"];
                        this.InstallationReport = response["FileName"];
                    }
                } else {
                    if (response["FileName"] != null) {
                        this.editTaskLocationData.ImageUploadFile = response["FileName"];
                        this.ImageUploadFile = response["FileName"];
                    }
                }

            }, (error) => {
                //FAILURE
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            }

        );
        this.showLoader = false;

    }



    // public CancelViewInstallationReport() {
    //     $('#ViewInstallationReport').modal('hide');
    // }

    // public CancelViewImageUploadFile() {
    //     $('#ViewImageUploadFile').modal('hide');
    // }

    public AddLocationTaskFormLoad() {

        $('#resetAddLocationTaskForm').trigger('click');
    }
    public AddCommentsFormLoad() {
        $('#resetaddTaskCommentForm').trigger('click');
    }

    openIRImage(item: any) {
        this.InstallationReport = item.InstallationReport;
        var IRReport = this.documentRoute + this.InstallationReport;
        window.open(IRReport);
    }

    openImage(item: any) {
        this.ImageUploadFile = item.ImageUploadFile;
        var ImageReport = this.documentRoute + this.ImageUploadFile;
        window.open(ImageReport);
    }


    public customerSelected() {
        this.addEditMultiLocationTaskData.TaskTitle = "";
        this.addEditMultiLocationTaskData.TaskDescription = "";
        this.addEditMultiLocationTaskData.ProjectId = "";
        if (this.addEditMultiLocationTaskData.CustomerId != "") {
            this.filter.CustomerId = this.addEditMultiLocationTaskData.CustomerId;
            this.userData = [];
            this.GetProjectData();
        }

    }

    public projectSelected() {
        if (this.addEditMultiLocationTaskData.ProjectId != "") {
            this.GetUserListForProject(this.addEditMultiLocationTaskData.ProjectId);
            this.getTaskGroupByProjectId(this.addEditMultiLocationTaskData.ProjectId);
            if (this.filter.TaskId == 0) {
                let objProjectItem: any = {};
                objProjectItem = this.projectListData.filter((project) => project.Project_Id == this.addEditMultiLocationTaskData.ProjectId)[0];
                console.log("Selected Project data");
                console.log(objProjectItem);
                this.addEditMultiLocationTaskData.TaskTitle = objProjectItem.Project_Title;
                if (objProjectItem.Project_Detail)
                    this.addEditMultiLocationTaskData.TaskDescription = objProjectItem.Project_Detail;
            }
        }
    }

    public vendorSelected() {
        if (this.addTaskLocationData.VendorId != "")
            this.addTaskLocationData.StatusId = 2;
    }


    private dateSorterPlannedEndDate(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.PlannedEndDate, 'DD/MM/YYYY');

        if (item.PlannedEndDate == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }

    private dateSorterCompletedOn(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.CompletedOn, 'DD/MM/YYYY');

        if (item.CompletedOn == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }

    private dateSorterLogDate(item: any) {
        let start = moment("01/01/1970", "DD/MM/YYYY")
        let date = moment(item.LogDate, 'DD/MM/YYYY');

        if (item.LogDate == "" || !date.isValid())
            return 0;
        return date.diff(start);
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/MultiLocationTask/multilocationtaskforms.component.ts
 **/